export default (theme: any) => ({
    alertContainer: {
        boxShadow: 'none',
        marginRight: 10,
        [theme.breakpoints.down('xl')]: {
            marginRight: '0px',
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: 0,
        },
    },

    dialogButton: {
        width: '100%',
        height: '56px',
        borderRadius: 0,
    },
})
